import { useSiteTheme } from 'src/contexts/SiteTheme/SiteThemeContext';
import { vars } from 'src/core/themes';
import { BoostIcon } from 'src/svgs/BoostIcon';
import { BoostIconLight } from 'src/svgs/BoostIconLight';
import { BoostStrategyIcon } from 'src/svgs/BoostStrategyIcon';
import { PosIconProps } from 'src/svgs/SvgWrapper';
import { SpendStrategy } from 'src/WebApiController';

function spendStrategyToLevel(
  strategy: SpendStrategy | null | undefined
): 1 | 2 | 3 | 4 | 5 {
  switch (strategy) {
    case SpendStrategy.HoldForBetterPrices:
      return 2;
    case SpendStrategy.SteadyHarvest:
      return 3;
    case SpendStrategy.MeasuredPush:
      return 4;
    case SpendStrategy.Accelerate:
      return 5;
    default:
      return 1;
  }
}

export const BoostIconDisplay = (
  props: Omit<PosIconProps, 'viewBox' | 'fill' | 'stroke'> & {
    isSelected?: boolean;
    inactive?: boolean;
    spendStrategy?: SpendStrategy | null;
  }
) => {
  const { isDarkMode } = useSiteTheme();

  if (props.spendStrategy !== undefined && !props.inactive) {
    const level = spendStrategyToLevel(props.spendStrategy);
    return <BoostStrategyIcon {...props} level={level} />;
  }

  return props.isSelected ? (
    <BoostIconLight
      {...props}
      inactive={props.inactive}
      activeFill={
        isDarkMode ? vars.color.surfacePrimary : vars.color.iconPrimaryInverted
      }
    />
  ) : (
    <BoostIcon {...props} inactive={props.inactive} />
  );
};
